<template>
  <div class="activity-widget-edit-wrap">
    <!-- 背景图片 -->
    <menu-item :label="$t('head.backImg')">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景图">
      <menu-background-image class="mt-2" :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景图">
      <menu-background-image class="mt-2" :target="model.mobileBackground" target-key="mobileBackground" />
    </menu-item>
    <!-- 布局 -->
    <menu-item :border-bottom="true" class="menu-item-switch pt-4 pb-3" :label="$t('menu.layout')">
      <menu-switch v-model="model.titleVisible" label="标题" target-key="titleVisible" />
      <menu-switch v-model="model.subtitleVisible" label="描述" target-key="subtitleVisible" />
      <menu-switch v-model="model.detailVisible" label="展示道具详情" target-key="detailVisible"></menu-switch>
    </menu-item>
    <menu-item label="卡片布局">
      <im-select v-model="model.layout" class="w-full" size="small" :options="cardLayoutOptions" />
    </menu-item>
    <menu-item label="卡片圆角">
      <menu-slider v-model="model.cardRadius" target-key="cardRadius" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>
    <menu-item label="金额和倒计时文字色">
      <menu-fill :target="model.amountColor" solid-color target-key="amountColor" />
    </menu-item>
    <menu-item label="金额和倒计时文字背景色">
      <menu-fill :target="model.amountBackground" target-key="amountBackground" />
    </menu-item>
    <menu-item label="奖品卡片背景">
      <menu-fill :target="model.cardBackground" target-key="cardBackground" />
      <menu-background-image class="mt-2" :target="model.cardBackground" target-key="cardBackground" />
    </menu-item>
    <menu-item label="奖品LOGO背景">
      <menu-fill :target="model.logoBackground" target-key="logoBackground" />
      <menu-background-image class="mt-2" :target="model.logoBackground" target-key="logoBackground" />
    </menu-item>
    <menu-item label="领取按钮">
      <menu-fill :target="model.getBackground" target-key="getBackground" />
      <menu-background-image class="mt-2" :target="model.getBackground" target-key="getBackground" />
    </menu-item>
    <menu-item label="领取文字色">
      <menu-fill :target="model.getTextColor" target-key="getTextColor" />
    </menu-item>
    <menu-item label="不可领取按钮">
      <menu-fill :target="model.disabledBackground" target-key="disabledBackground" />
      <menu-background-image class="mt-2" :target="model.disabledBackground" target-key="disabledBackground" />
    </menu-item>
    <menu-item label="不可领取文字色">
      <menu-fill :target="model.disabledTextColor" target-key="disabledTextColor" />
    </menu-item>
    <menu-item label="进度条背景">
      <menu-fill :target="model.progressBackground" target-key="progressBackground" />
      <menu-background-image class="mt-2" :target="model.progressBackground" target-key="progressBackground" />
    </menu-item>
    <menu-item label="进度条填充">
      <menu-fill :target="model.innerBackground" target-key="innerBackground" />
      <menu-background-image class="mt-2" :target="model.innerBackground" target-key="innerBackground" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import { ActivityWidgetModel } from '../../model/index'
import MenuItem from "~/components/menu/menuItem";
import MenuSwitch from "~/components/menu/menuSwitch";
import ImSelect from "~/components/common/ImSelect";
import MenuFill from "~/components/menu/menuFill";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage";
import MenuSlider from '~/components/menu/menuSlider.vue'
import { AccumulationLayoutEnum } from '~/enums/data'

export default {
  name: "ActivityWidgetEdit",
  components: {
    ImSelect,
    MenuSlider,
    MenuItem,
    MenuSwitch,
    MenuFill,
    MenuBackgroundImage
  },
  props: {
    model: {
      type: Object,
      default() {
        return new ActivityWidgetModel()
      }
    }
  },
  data() {
    return {
      menuList: [],
      cardLayoutOptions: [
        {
          label: '一行展示',
          value: AccumulationLayoutEnum.Row
        },
        {
          label: '全部展示',
          value: AccumulationLayoutEnum.Col
        }
      ]
    }
  },

  methods: {
  }
}
</script>

<style lang='less' scoped>
</style>
<style lang="less">
.activity-rich-text {
  position: relative;
  margin-bottom: 16px;
  .ql-editor.ql-blank::before {
    color: rgba(255, 255, 255, 0.3);
    font-style: normal;
  }
  .ql-bubble {
    .ql-tooltip {
      position: absolute;
      top: 38px !important;
      left: 0 !important;
      background: #151724 !important;
      border: 0.5px solid rgba(255, 255, 255, 0.3);
      z-index: 2021;
    }
  }
  .rich-text {
    border-radius: 2px;
    &:hover {
      box-shadow: none;
    }
  }
}
</style>
